import React, { useState, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import AuthService from "../../services/auth.service";

const SignupForm = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const captchaRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    // reset captcharef on submit
    const recaptcha_token = captchaRef.current.getValue();
    captchaRef.current.reset();

    AuthService.signup({ username, email, password, recaptcha_token })
      .then((res) => {
        setMessage("Sign up Successful! Please check your email to confirm the sign up");
      })
      .catch((err) => {
        console.error('err: sign up failed', err);
        if (err && err.response && err.response.data){
          setMessage(`Sign up Failed! ${err.response.data}`)
        }
      });
  };

  return (
    <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
      <input type="hidden" name="remember" value="true" />
      <div className="rounded-md shadow-sm -space-y-px">
        <div style={{margin:"1.5vh"}}>
          <label htmlFor="username" className="sr-only" style={{marginRight:"1.5vh"}}>
            Username
          </label>
          <input
            className="input-field"
            id="username"
            name="username"
            type="text"
            autoComplete="username"
            required
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        <div style={{margin:"1.5vh"}}>
          <label htmlFor="email-address" className="sr-only" style={{marginRight:"1.5vh"}}>
            Email address
          </label>
          <input
            className="input-field"
            id="email-address"
            name="email"
            type="email"
            autoComplete="email"
            required
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div style={{margin:"1.5vh"}}>
          <label htmlFor="password" className="sr-only" style={{marginRight:"1.5vh"}}>
            Password
          </label>
          <input
            className="input-field"
            id="password"
            name="password"
            type="password"
            autoComplete="current-password"
            required
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
      </div>
      <div>
        <ReCAPTCHA
          className="verifier" 
          sitekey={ process.env.REACT_APP_RECAPTCHA_SITE_KEY}
          ref={captchaRef}
        />
      </div>
      <div style={{margin:"1.5vh"}}>
        <button
          type="submit"
          className="custom-button"
          style={{padding: "1vh 3vh 1vh 3vh"}}
        >
          Sign up
        </button>
      </div>

      <div style={{margin:"1.5vh"}}>
        {message}
      </div>

    </form>
  );
};

export default SignupForm;
